import { render, staticRenderFns } from "./checkList2.vue?vue&type=template&id=388d4829&scoped=true&"
import script from "./checkList2.vue?vue&type=script&lang=js&"
export * from "./checkList2.vue?vue&type=script&lang=js&"
import style0 from "./checkList2.vue?vue&type=style&index=0&id=388d4829&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388d4829",
  null
  
)

export default component.exports